import type { ProtocolEdgeType } from '../edges/constants';
import type { NodeSn } from '../nodes/types';

export interface EdgeEntityDataAttributes {
  area?: string | null;
  as?: number | null;
  cost?: number | null;
  intName?: string | null;
  intDescription?: string | null;
  ipAddress?: string | null;
  media?: string | null;
  prefix?: number | null;
  sn?: NodeSn | null;
  vrf?: string | null;
  // STPi
  isForwarding?: boolean;
  vlanPortStatus?: string | null;

  // null = attribute valid for given edge type with empty value (e.g. sn for connection to transit node)
  // undefined = this edge type doesn't have such attribute (e.g. STP protocol doesn't have ipAddress)
}

export interface EdgeEntityData {
  id: string;
  protocol?: ProtocolEdgeType;
  source: EdgeEntityDataAttributes;
  target: EdgeEntityDataAttributes;
  vlanId?: number | null;
}

export type EdgeEntityDataResponse = EdgeEntityData[];
